import React, {useMemo, useRef} from "react";
import {OverlayPanel} from "primereact/overlaypanel";
import {ListBox} from "primereact/listbox";
import {InputText} from "primereact/inputtext";
import Icon from "../../../system/components/icon";
import {useTranslate} from "../../../system/useTranslate";

function SelectCustomer({
                            selectedCustomer,
                            customers = [],
                            onChange
                        }) {
    const translate = useTranslate();
    const overlayRef = useRef(null);

    const options = useMemo(() => {
        const safeCustomers = Array.isArray(customers)
            ? customers
            : [];

        return safeCustomers.map(customer => ({
            label: customer.displayName || customer.fullname || customer.companyName || customer.company || "---",
            searchableText: [
                customer.displayName,
                customer.fullname,
                customer.companyName,
                customer.company,
                customer.primaryPhone,
                customer.phonenumber
            ]
                .filter(Boolean)
                .join(" "),
            value: customer.documentId || customer.id,
            data: customer
        }));
    }, [customers, translate]);


    function ItemTemplate(option) {
        const customer = option?.data;

        return (
            <div className="flex align-items-center gap-2 p-2">
                <Icon
                    icon={
                        customer?.companyName || customer?.company
                            ? "mi mi:business"
                            : "mi mi:person"
                    }
                    className="text-lg"
                />

                <div className="flex flex-column gap-1">
                    <span className="text-xs">
                        {option?.label}
                    </span>

                    {(customer?.companyName || customer?.company) && (
                        <span className="text-2xs text-400">
                            {customer.companyName || customer.company}
                        </span>
                    )}
                </div>
            </div>
        );
    }

    return (
        <div className="flex align-items-center gap-1">
            <div
                className="flex align-items-center cursor-pointer"
                onClick={(event) =>
                    overlayRef.current?.toggle(event)
                }
            >
                {selectedCustomer ? (
                    <>
                        <ItemTemplate
                            label={
                                selectedCustomer.displayName ||
                                selectedCustomer.fullname ||
                                selectedCustomer.companyName ||
                                selectedCustomer.company ||
                                "---"
                            }
                            data={selectedCustomer}
                        />

                        <Icon
                            icon="mi mi:keyboard_arrow_down"
                            className="text-lg"
                        />
                    </>
                ) : (
                    <Icon
                        icon="mi mi:add_circle"
                        className="text-lg"
                    />
                )}
            </div>

            <OverlayPanel
                ref={overlayRef}
                pt={{
                    root: () => ({
                        className:
                            "p-0 rtl w-15rem project-overlay"
                    }),
                    content: () => ({
                        className: "p-0"
                    })
                }}
            >
                <ListBox
                    className="w-15rem border-none"
                    filter
                    filterBy="label,searchableText"
                    options={options}
                    value={selectedCustomer?.documentId || selectedCustomer?.id || -1}
                    optionLabel="label"
                    optionValue="value"
                    itemTemplate={ItemTemplate}
                    pt={{
                        item: () => ({
                            className: "p-0"
                        }),
                        header: () => ({
                            className:
                                "p-1 border-none shadow-none"
                        }),
                        list: () => ({
                            className: "max-h-15rem overflow-auto"
                        })
                    }}
                    filterTemplate={(filterOptions) => (
                        <div className="p-2">
                            <InputText
                                className="p-2 w-full text-xs"
                                placeholder={translate("search")}
                                onChange={
                                    filterOptions
                                        .filterOptions
                                        .filter
                                }
                            />
                        </div>
                    )}
                    onChange={(event) => {
                        const selected =
                            customers.find(
                                customer =>
                                    (customer.documentId || customer.id) === event.value
                            ) ?? null;

                        onChange?.(selected);
                        overlayRef.current?.hide();
                    }}
                />
            </OverlayPanel>
        </div>
    );
}

export default SelectCustomer;
